import axios from 'axios'

import { parseError } from '../../../helpers'

const INITIAL_STATE = {
  error: false,
  isLoaded: false,
  items: [],
}

const FETCH_SUPPLIERS = 'FETCH_SUPPLIERS'
const POPULATE_SUPPLIERS = 'POPULATE_SUPPLIERS'
const SET_SUPPLIERS_ERROR = 'SET_SUPPLIERS_ERROR'

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_SUPPLIERS:
      return {
        ...state,
        items: [],
        isLoaded: false,
      }
    case POPULATE_SUPPLIERS:
      return {
        ...state,
        items: action.payload,
        isLoaded: true,
      }
    case SET_SUPPLIERS_ERROR:
      return {
        ...state,
        error: action.payload,
        isLoaded: true,
      }
    default:
      return state
  }
}

export const fetchSuppliersAction = () => async dispatch => {
  try {
    dispatch({ type: SET_SUPPLIERS_ERROR, payload: false })
    dispatch({ type: FETCH_SUPPLIERS })
    const response = await axios.get('/getSuppliers')
    dispatch({
      type: POPULATE_SUPPLIERS,
      payload: response.data,
    })
  } catch (e) {
    dispatch({
      type: SET_SUPPLIERS_ERROR,
      payload: parseError(`fetchSuppliersAction - ${parseError(e)}`),
    })
  }
}

export default reducer
